export default __webpack_public_path__ + "static/DSC_6452-995853352654380298ba89d3c0e03076.jpg";